import React, {useState, useEffect, 
	//useRef
	
} from 'react';
import { useParams } from 'react-router-dom';

import { connect } from 'react-redux';
import { loadMap } from '../../Flux/thunks';

import { CalciteAction, CalciteActionBar, CalciteActionGroup, 
	//CalciteBlock, CalciteBlockSection, 
	CalciteShellPanel, CalcitePanel, 
	CalciteShell,
	 CalciteShellCenterRow, 
} from "@esri/calcite-components-react";

import Map from './Components/Map';
import BasemapGalleryPanel from './Panels/Core/BasemapGalleryPanel';
import LegendPanel from './Panels/Core/LegendPanel';
import AlertList from './Panels/Core/AlertList';

import MapLayersPanel from './Panels/Core/MapLayersPanel';
import ServerBrowserPanel from './Panels/Core/ServerBrowserPanel';
import SaveSharePrintPanel from './Panels/Core/SaveSharePrintPanel';
import FindLocationPanel from './Panels/Core/FindLocationPanel';

//import StockLayerControlPanel from './Panels/Custom/StockLayerControlPanel';
import LayerControlPanel from './Panels/Core/LayerControlPanel';
import DebugPanel from './Panels/Core/DebugPanel';
//import GraphingPanel from './Panels/Custom/GraphingPanel';
//import GraphCenterPanel from './Panels/Custom/GraphingPanel/GraphCenterPanel';
import FloatingCalciteTip from '../../Common/FloatingCalciteTip';

//Custom modules
import DataForGrowersPanel from './Panels/Custom/DataForGrowersPanel';
import DataForRegulatorsPanel from './Panels/Custom/DataForRegulatorsPanel';
import DataForResearchersPanel from './Panels/Custom/DataForResearchersPanel';
import GraphingPanel from './Panels/Custom/GraphingPanel';
import GraphCenterPanel from './Panels/Custom/GraphingPanel/GraphCenterPanel';
import QuickStartModal from './Panels/Custom/QuickStartModal';

import UploadShapefile from './Panels/Custom/UploadShapefile';

const MapPage = ({ isMapLoading, isLayerLoading, arcgisMap, getUrlOptions, startLoadingMap }) => {
	
	//In the tutorial, I didn't need to add the function into use effect
  	let { shareMapKey } = useParams();
	const [primaryToggle, SetPrimaryToggle] = useState(
		(getUrlOptions && getUrlOptions.isMinimal) ? false : true
	);
	const [auxToggle, SetAuxToggle] = useState(true);

	const [showPrimaryContent, SetShowPrimaryContent] = useState(
		(getUrlOptions && getUrlOptions.isMinimal ? 'legend' : null)
	);
	const [showAuxContent, SetShowAuxContent] = useState(null);

	//Modals
	const [isQuickStartActive, setQuickStartActive] = useState(false);


	const TogglePrimaryPanel = ( primaryContent ) => {
		
		//primary content already open
		if( showPrimaryContent === primaryContent ) {
			SetPrimaryToggle(true);
			SetShowPrimaryContent(null);
			return;
		}

		SetPrimaryToggle(false);
		SetShowPrimaryContent(primaryContent);
		return;
	}
	
	const ToggleAuxPanel = ( auxContent ) => {
		
		//primary content already open
		if( showAuxContent === auxContent ) {
			SetAuxToggle(true);
			SetShowAuxContent(null);
			return;
		}

		SetAuxToggle(false);
		SetShowAuxContent(auxContent);
		return;
	}

	//console.log('Is Minimal? ', getUrlOptions.isMinimal, ((getUrlOptions ? getUrlOptions.isMinimal : false ) || showPrimaryContent === 'legend'));

	useEffect( () => {
		startLoadingMap(shareMapKey);
	}, [startLoadingMap, shareMapKey]);

//CalciteActions can have loading="true" to show a loader.

	return ( 
		<CalciteShell>
			<CalciteShellPanel slot="primary-panel" position="start" widthScale="m" detached="true" detachedHeightScale="l" collapsed={primaryToggle} >
				<CalciteActionBar hidden={getUrlOptions ? getUrlOptions.isMinimal : null} slot="action-bar" expanded={true}>
					{ process.env.NODE_ENV === 'development' ?
						<CalciteActionGroup>
							<CalciteAction active={showPrimaryContent==='debug' || null} text="DEBUG PANEL" icon="debug" onclick={(_e) => { TogglePrimaryPanel('debug'); }}></CalciteAction>
							<CalciteAction active={showPrimaryContent==='upload-shapefile' || null} text="Upload Shapefile" icon="upload" onclick={(_e) => { TogglePrimaryPanel('upload-shapefile'); }}></CalciteAction>
						</CalciteActionGroup>
					: null}
					<CalciteActionGroup>
						<CalciteAction active={showPrimaryContent==='data-for-growers' || null} 
							text="Quick View" icon="automation" onclick={(_e) => { TogglePrimaryPanel('data-for-growers'); }}></CalciteAction>
						{/*<CalciteAction active={showPrimaryContent==='data-for-regulators' || null} text="Data for Regulators" icon="access-string-results" onclick={(_e) => { TogglePrimaryPanel('data-for-regulators'); }}></CalciteAction>*/}
						<CalciteAction active={showPrimaryContent==='data-for-researchers' || null} text="Detailed View" icon="beaker" onclick={(_e) => { TogglePrimaryPanel('data-for-researchers'); }}></CalciteAction>
						<CalciteAction className="test" style={{backgroundColor:'blue'}}
						scale='m'
							 active={showPrimaryContent==='graphing' || null} text="Data Graphing" icon="graph-bar" 
							onclick={(_e) => { TogglePrimaryPanel('graphing'); }}></CalciteAction>
					</CalciteActionGroup>
					<CalciteActionGroup>
						<CalciteAction text="Quick Start Guide" icon="lightbulb" onclick={(_e) => { 
							setQuickStartActive(true);
						}}></CalciteAction>
						<CalciteAction active={showPrimaryContent==='map-layers' || null} text="Map Layers" icon="layers" onclick={(_e) => { TogglePrimaryPanel('map-layers'); }}></CalciteAction>
						<CalciteAction active={showPrimaryContent==='server-browser' || null} text="Import Data" icon="data-magnifying-glass" onclick={(_e) => { TogglePrimaryPanel('server-browser'); }}></CalciteAction>
						<CalciteAction active={showPrimaryContent==='basemaps' || null} text="Basemap" icon="basemap" onclick={(_e) => { TogglePrimaryPanel('basemaps'); }}></CalciteAction>
						<CalciteAction active={showPrimaryContent==='find-location' || null} text="Find Location" icon="search" onclick={(_e) => { TogglePrimaryPanel('find-location'); }}></CalciteAction>
						<CalciteAction active={showPrimaryContent==='save' || null} text="Save / Share / Print" icon="save" onclick={(_e) => { TogglePrimaryPanel('save'); }}></CalciteAction>
						<CalciteAction active={showPrimaryContent==='legend' || null} text="Legend" icon="legend" onclick={(_e) => { TogglePrimaryPanel('legend'); }}></CalciteAction>
					</CalciteActionGroup>
				</CalciteActionBar>
				<CalcitePanel  
					
					dismissible={false}
					open={showPrimaryContent === 'debug'}
					style={{marginTop: '0', display:( showPrimaryContent === 'debug' ? 'flex' : 'none' )}}
					heading="DEBUG"
					summary="Random assortment of stuff.">
						<DebugPanel arcgisMap={arcgisMap} />
				</CalcitePanel>

				<CalcitePanel  
					
					dismissible={false}
					open={showPrimaryContent === 'upload-shapefile'}
					style={{marginTop: '0', display:( showPrimaryContent === 'upload-shapefile' ? 'flex' : 'none' )}}
					heading="Upload Shapefile"
					summary="Upload Shapefile Test">
						<UploadShapefile arcgisMap={arcgisMap} />
				</CalcitePanel>


				<CalcitePanel  
					
					dismissible={false}
					open={showPrimaryContent === 'debug'}
					style={{marginTop: '0', display:( showPrimaryContent === 'debug' ? 'flex' : 'none' )}}
					heading="DEBUG"
					summary="Random assortment of stuff.">
						<DebugPanel arcgisMap={arcgisMap} />
				</CalcitePanel>


				<CalcitePanel  
					dismissible={false}
					open={showPrimaryContent === 'data-for-growers'}
					style={{marginTop: '0', display:( showPrimaryContent === 'data-for-growers' ? 'flex' : 'none' )}}
					heading="Quick View"
					summary="This is the [Quick View] Panel.">
					<DataForGrowersPanel arcgisMap={arcgisMap} panelIsOpen={showPrimaryContent === 'data-for-growers'} />
				</CalcitePanel>
				<CalcitePanel  
					open={showPrimaryContent === 'data-for-regulators'}
					style={{display:( showPrimaryContent === 'data-for-regulators' ? 'flex' : 'none' )}}
					heading="Data for Regulators"
					summary="This is the [Data for Regulators] Panel.">
					<DataForRegulatorsPanel />
				</CalcitePanel>
				<CalcitePanel  
					open={showPrimaryContent === 'data-for-researchers'}
					style={{display:( showPrimaryContent === 'data-for-researchers' ? 'flex' : 'none' )}}
					heading="Detailed View"
					summary="This is the [Detailed View] Panel.">
						<DataForResearchersPanel />
				</CalcitePanel>


				<CalcitePanel  
					open={showPrimaryContent === 'graphing'}
					style={{marginTop: '0', display:( showPrimaryContent === 'graphing' ? 'flex' : 'none' )}}
					heading="Graphing"
					summary="Create some graphs here.">
					
					<GraphingPanel  />
				</CalcitePanel>


				<CalcitePanel  
					open={showPrimaryContent === 'server-browser'}
					style={{marginTop: '0', display:( showPrimaryContent === 'server-browser' ? 'flex' : 'none' )}}
					heading="Import Data"
					summary="Browse layers online">
					
					<ServerBrowserPanel isMapLoading={isMapLoading} arcgisMap={arcgisMap} />
				</CalcitePanel>
				
				<CalcitePanel  
					
					dismissible={false}
					open={showPrimaryContent === 'map-layers'}
					style={{marginTop: '0', display:( showPrimaryContent === 'map-layers' ? 'flex' : 'none' )}}
					heading="Map Layers"
					summary="Add layers to map here.">
					<MapLayersPanel isMapLoading={isMapLoading} arcgisMap={arcgisMap} />
				</CalcitePanel>


				<CalcitePanel  
					dismissible={false}
					open={showPrimaryContent === 'basemaps'}
					style={{marginTop: '0', display:( showPrimaryContent === 'basemaps' ? 'flex' : 'none' )}}
					heading="Basemaps"
					summary="Select a basemap">
					<BasemapGalleryPanel arcgisMap={arcgisMap} isMapLoading={isMapLoading}/>
					
				</CalcitePanel>
				<CalcitePanel  
					dismissible={false}
					open={showPrimaryContent === 'find-location'}
					style={{marginTop: '0', display:( showPrimaryContent === 'find-location' ? 'flex' : 'none' )}}
					heading="Find Location"
					summary="Find a point on the map.">
					<FindLocationPanel arcgisMap={arcgisMap} isMapLoading={isMapLoading} />
				</CalcitePanel>


				<CalcitePanel  
					dismissible={false}
					open={showPrimaryContent === 'save'}
					style={{marginTop: '0', display:( showPrimaryContent === 'save' ? 'flex' : 'none' )}}
					heading="Save / Share / Print"
					summary="Save, share, or print your map."
					loading={isMapLoading}
					>
					<SaveSharePrintPanel arcgisMap={arcgisMap} isMapLoading={isMapLoading} />
				</CalcitePanel>

				<CalcitePanel  
					dismissible={false}
					open={showPrimaryContent === 'legend'}
					style={{marginTop: '0', display:( showPrimaryContent === 'legend' ? 'flex' : 'none' )}}
					heading="Legend"
					summary="The Legend for the map.">
					<LegendPanel arcgisMap={arcgisMap} isMapLoading={isMapLoading} />
				</CalcitePanel>
			</CalciteShellPanel>
			<CalciteShellPanel 
				slot="contextual-panel" 
				position="end" 	
				widthScale="m" detached="true" detachedHeightScale="l" collapsed={auxToggle}
			>
				<CalciteActionBar slot="action-bar" position="end" theme="dark"  className="calcite-theme-dark"
				 hidden={getUrlOptions ? getUrlOptions.isMinimal : null}
				>
					<CalciteAction text="Layer Control" icon="map-contents" onclick={(_e) => { ToggleAuxPanel('layer-control'); }}></CalciteAction>
				</CalciteActionBar>
				<CalcitePanel 
					dismissible={false}
					loading={isMapLoading}
					open={showAuxContent === 'layer-control'}
					style={{marginTop: '0', display:( showAuxContent === 'layer-control' ? 'flex' : 'none' )}}
					heading="Layer Control"
					summary="Change your layer options here">
					<LayerControlPanel arcgisMap={arcgisMap} />
				</CalcitePanel>
			</CalciteShellPanel>

			<CalciteShellCenterRow slot="center-row">
				<Map  arcgisMap={arcgisMap} loading={isMapLoading || isLayerLoading} />
			</CalciteShellCenterRow>

			<QuickStartModal active={isQuickStartActive} CloseModal={() => {
				setQuickStartActive(false);
			} }/>

			<GraphCenterPanel />
			

			<AlertList />
			<FloatingCalciteTip />
		</CalciteShell>

	
	
	);
}
//<Map view={view} webmap={webmap} />


//what state items should this component have access to
const mapStateToProps = (state) => ({
    //todos: state.todos,
	arcgisMap: state.arcgisMap,
    isMapLoading: state.isMapLoading,
    isLayerLoading: state.isLayerLoading,
    getUrlOptions: state.getUrlOptions
    //alertList: state.alertList
	
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	startLoadingMap: (shareMapKey) => {dispatch(loadMap(shareMapKey))},
	//onAlertClose: (key) => {dispatch(closeAlert(key))}
});

export default connect(mapStateToProps, mapDispatchToProps)(MapPage);
